import React from "react";
import Breadcrumb from "../components/Breadcrumb";

export default function BrandBuilding() {
  return (
    <>
      <Breadcrumb title="Brand Building" />

      <div className="page-service-single">
        <div className="container">
          {/* Main Content */}
          <div className="row">
            <div className="col-lg-12">
              <div className="service-single-content">
                {/* Featured Image */}
                <div className="service-featured-image">
                  <figure className="image-anime reveal">
                    <img
                      src="/assets/images/brand.png"
                      alt="Brand Building Services"
                      loading="lazy"
                    />
                  </figure>
                </div>

                {/* Entry Content */}
                <div className="service-entry">
                  <p className="wow fadeInUp" data-wow-delay="0.25s">
                    We help organizations build strong, credible digital brands
                    that inspire trust and consistency across every touchpoint.
                    Our branding and communication solutions ensure clarity,
                    alignment, and impact in regulated healthcare markets.
                  </p>

                  <h4 className="mb-2">What we do</h4>
                  <ul>
                    <li>Brand positioning and messaging frameworks</li>
                    <li>Digital brand identity and communication strategy</li>
                    <li>Omni-channel communication planning</li>
                    <li>Marketing creatives aligned with brand guidelines</li>
                  </ul>

                  <h4 className="mb-2 mt-2">Value we create</h4>
                  <ul>
                    <li>Clear and consistent brand presence</li>
                    <li>
                      Stronger credibility with customers and stakeholders
                    </li>
                    <li>Improved brand recall and engagement</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          {/* Sidebars */}
          <div className="row">
            <ServiceSidebar
              title="Digital Branding & Communication"
              sections={[
                {
                  heading: "Brand Strategy & Identity",
                  items: [
                    "Brand positioning & messaging",
                    "Brand voice & tone development",
                    "Logo design & visual identity",
                    "Brand guidelines",
                    "Corporate presentations & brand decks",
                  ],
                },
                {
                  heading: "Creative & Visual Communication",
                  items: [
                    "Graphic design for digital platforms",
                    "Website visuals & UI assets",
                    "Social media brand templates",
                    "Brochure & flyer design",
                    "Corporate videos & motion graphics",
                    "Infographics & data visualization",
                  ],
                },
                {
                  heading: "Content & Communication",
                  items: [
                    "Website copywriting",
                    "Product descriptions",
                    "Corporate communications",
                    "Press releases",
                    "Thought-leadership content",
                    "Emailers & newsletters",
                  ],
                },
                {
                  heading: "Reputation & Presence",
                  items: [
                    "Online reputation management (ORM)",
                    "Brand monitoring & sentiment analysis",
                    "Competitor benchmarking",
                  ],
                },
              ]}
            />

            <ServiceSidebar
              title="Marketing Services"
              sections={[
                {
                  heading: "Advertising & Awareness",
                  items: [
                    "Social media ads",
                    "Google Ads (Search, Display, Video)",
                    "Retargeting & remarketing",
                    "Programmatic advertising",
                  ],
                },
                {
                  heading: "Performance Marketing",
                  items: [
                    "Conversion rate optimization (CRO)",
                    "Landing page optimization",
                    "Lead generation campaigns",
                    "A/B testing",
                  ],
                },
                {
                  heading: "Content Marketing",
                  items: [
                    "SEO blogs & articles",
                    "Whitepapers & case studies",
                    "Video content strategy",
                    "Email marketing & drip campaigns",
                  ],
                },
                {
                  heading: "Campaign Management",
                  items: [
                    "Campaign planning & execution",
                    "Multi-channel calendars",
                    "Reporting & optimization",
                  ],
                },
                {
                  heading: "Market Research",
                  items: [
                    "Audience research",
                    "Competitor analysis",
                    "Brand perception surveys",
                  ],
                },
              ]}
            />

            <ServiceSidebar
              title="Omnichannel Management"
              sections={[
                {
                  heading: "Customer Experience",
                  items: [
                    "Unified customer journey design",
                    "Cross-channel integration",
                    "Personalization & segmentation",
                  ],
                },
                {
                  heading: "Channel Operations",
                  items: [
                    "Social media management",
                    "Email & WhatsApp automation",
                    "SMS & app messaging",
                  ],
                },
                {
                  heading: "CRM & Automation",
                  items: [
                    "CRM integrations",
                    "Automated workflows",
                    "Cross-channel dashboards",
                  ],
                },
                {
                  heading: "Analytics & Reporting",
                  items: [
                    "Customer behavior analytics",
                    "Attribution modeling",
                    "ROI analysis",
                  ],
                },
                {
                  heading: "Customer Support",
                  items: [
                    "Chatbot automation",
                    "24/7 omnichannel support",
                    "Ticketing system integration",
                  ],
                },
              ]}
            />
          </div>
        </div>
      </div>
    </>
  );
}

/* ✅ Reusable Sidebar Component */
function ServiceSidebar({ title, sections }) {
  return (
    <div className="col-lg-4">
      <div className="service-sidebar">
        <div className="services-list-box wow fadeInUp" data-wow-delay="0.5s">
          <h3>{title}</h3>

          {sections.map((section, idx) => (
            <div key={idx}>
              <p>
                <strong>→ {section.heading}</strong>
              </p>
              <ul>
                {section.items.map((item, i) => (
                  <li key={i}>{item}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
